
import { defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex'
import IntersectionObserverComponent from '@directives/intersectionObserver.vue'
import deviceResolution from '@scripts/mixins/device-resolution'
const { mapGetters: mapGettersGenesys } = createNamespacedHelpers('genesys')
export default defineComponent({
  name: 'ChatBotFooterButton',
  components: { IntersectionObserverComponent },
  mixins: [deviceResolution],
  props: {
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGettersGenesys(['chatBotConfig','scriptLoaded','chatBotStatus']),
  },
  methods: {
    fetchChatScript() {
        this.$genesys.preFetchScript()
    },
  },
})
